<template>
  <div class="new-loading rz">
    <div class="loading-left">
      <div class="loading-icon contain"></div>
    </div>
    <div class="loading-right">
      <div class="loading-right-top"></div>
      <div class="loading-right-bottom" :style="{background:bottomColor}" ></div>
      <div class="name" v-if="selectColorItem">{{ selectColorItem.title }}</div>
      <div class="car-img-box" v-if="colorTarArr.length" :class="carId">
        <img v-for="(item,index) in colorTarArr" :class="{active:index === activeIndex}"
             :src="require(`../static/exportImg/${carId}/${item.code}.png`)" alt="" class="box-img">
      </div>
      <div class="progress_area">
        <div class="progress-box">
          <div id="progress" :style="{width: progress+'%'}"></div>
        </div>
        <div id="percentNum">{{ progress }}%</div>
      </div>
    </div>

  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  props: ['progress'],
  data() {
    return {
      colorImageTar: {},
      activeIndex:0,
      activeCode:''
    }
  },
  computed:{
    ...mapState({
      carConfig: state => state.carConfig,
      colorConfig: state => state.colorConfig,
    }),
    carId: vm => vm.carConfig.id,
    colorTarArr: vm =>vm.useColorArr.map(code => Object.values(vm.colorConfig).find(o => o.code === code) || {}),
    useColorArr:vm => (vm.carConfig.loadingColorList || vm.colorArr)||[],
    selectColorItem:vm=>vm.colorTarArr[vm.activeIndex],
    bottomColor:vm=>vm.selectColorItem?(
        Array.isArray(vm.selectColorItem.color)?vm.selectColorItem.color[0]:vm.selectColorItem.color
    ):'#000'
  },
  methods:{
    changeColor(index){
      this.activeIndex = index
      clearTimeout(this._timer)
      this._timer = setTimeout(() => {
        let nowIndex = this.activeIndex+1
        nowIndex = nowIndex === this.useColorArr.length ? 0 : nowIndex

        this.activeIndex = nowIndex
        this.changeColor(nowIndex)
      }, 2500)
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.changeColor(0)
    })
  }
}
</script>
<style scoped lang="less">
.contain{
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
@media (min-width: 960px)  {
  .new-loading {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    left: 0;
    top: 0;
    display: flex;
    .loading-left{
      height: 100%;
      width: 18.75vw;
      background: white;
      .loading-icon{
        width: 11.96429vw;
        height: 3.57143vw;
        position: absolute;
        left: 2.86vw;
        top: 2.86vw;
        background-image: url("../static/img/loading-icon.png");
      }
    }
    .loading-right{
      flex: 1;
      position: relative;
      .loading-right-top{
        width: 100%;
        height: 45vh;
        background: #141414;
      }
      .loading-right-bottom{
        width: 100%;
        height: 55vh;
      }
      .name{
        position: absolute;
        z-index: 2;
        width: 100%;
        font-size: 1.96429vw;
        font-style: normal;
        font-weight: 400;
        text-align: center;
        top: 3.57vw;
        background: linear-gradient(180deg, #FFF 0%, rgba(231, 231, 231, 0.20) 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .car-img-box{
        position: absolute;
        z-index: 2;
        left: 50%;
        top: 50%;
        width: 68.21429vw;
        height: 34.10714vw;
        max-height: 62vh;
        transform: translate(-50%,-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        &.gx{
          height: 46vw;
        }
        &.rx{
          height: 56vmax;
        }
        .box-img{
          max-height: 100%;
          width: auto;
          position: absolute;
          opacity: 0;

          &.active {
            opacity: 1;
          }
        }
      }

      .progress_area{
        position: absolute;
        z-index: 3;
        bottom: 9vh;
        width: 60vw;
        left: 50%;
        transform: translate(-50%);
        .progress-box{
          width: 100%;
          height: 4px;
          border-radius: 2px;
          background: rgba(255, 255, 255, 0.32);
        }
        #progress {
          width: 0%;
          position: absolute;
          left: 0;
          z-index: 4;
          height: 4px;
          border-radius: 2px;
          background: #1E293B;
          transition: width 0.2s ease-out;
        }

        #percentNum {
          position: absolute;
          color: #1E293B;
          width: 100%;
          text-align: center;
          top: 20px;
          font-size: 20px;
          font-style: normal;
          font-weight: 400;
        }
      }
    }
  }
}
@media (max-width: 960px)  {
  .new-loading {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    left: 0;
    top: 0;
    display: flex;
    .loading-left{
      .loading-icon{
        width: 36.19707vw;
        height: 8.8vw;
        position: absolute;
        left: 5.33vw;
        top: 10.66vw;
        background-image: url("../static/img/loading-icon-w.png");
      }
    }
    .loading-right{
      width: 100%;
      height: 100%;
      .loading-right-top{
        width: 100%;
        height: 45vh;
        background: #141414;
      }
      .loading-right-bottom{
        width: 100%;
        height: 55vh;
      }

      .name{
        position: absolute;
        z-index: 2;
        width: 100%;
        top: 20vh;
        text-align: center;
        font-size: 5.86667vw;
        font-style: normal;
        font-weight: 400;
        background: linear-gradient(180deg, #FFF 0%, rgba(231, 231, 231, 0.20) 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .car-img-box{
        position: absolute;
        z-index: 2;
        left: 50%;
        top: 47%;
        width: 100vw;
        height: 160vw;
        max-height: 62vh;
        transform: translate(-50%,-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        &.gx{
          width: 120vw;
        }
        &.rx{
          width: 120vw;
        }
        .box-img{
          max-width: 100%;
          height: auto;
          position: absolute;
          opacity: 0;

          &.active {
            opacity: 1;
          }
        }
      }
      .progress_area{
        position: absolute;
        z-index: 3;
        bottom: 16vh;
        width: 60vw;
        left: 50%;
        transform: translate(-50%);
        .progress-box{
          width: 100%;
          height: 4px;
          border-radius: 2px;
          background: rgba(255, 255, 255, 0.32);
        }
        #progress {
          width: 0%;
          position: absolute;
          left: 0;
          z-index: 4;
          height: 4px;
          border-radius: 2px;
          background: #1E293B;
          transition: width 0.2s ease-out;
        }

        #percentNum {
          position: absolute;
          color: #1E293B;
          width: 100%;
          text-align: center;
          top: 12px;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
